import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateAccessory($companyId: ID!, $attributes: AccessoryAttributes!) {
    createAccessory(companyId: $companyId, attributes: $attributes) {
       accessory {
        id
        ...CreatedAccessory
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedAccessory on Accessory {
    id
    assetType {
      id
    }
    quantity
  }
`
